// src/components/Layout.jsx
import SideBar from './sideBar/SideBar'
import { Header } from './header/Header'
import { SidebarProvider } from './sideBar/SidebarContext'
import { useLocation } from 'react-router-dom'
import AssistantPet from '../modules/ui/AssistantPet'
import { TryLucaChatProvider } from '../modules/views/contableAgent/context/TryLucaChatContext'
import SupportSessionBanner from './SupportSessionBanner'

const Layout = ({ children, className = '' }) => {
  const location = useLocation()
  const isBusinessPage =
    location.pathname === '/' || location.pathname === '/BusinessInsights'

  return (
    <SidebarProvider>
      <TryLucaChatProvider>
        {/* Usamos h-screen para fijar la altura al viewport */}
        <div className="flex h-screen overflow-hidden bg-slate-100/70">
          <SideBar />
          <AssistantPet />

          {/* Contenedor principal: flex-col para header + main */}
          <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-x-hidden overflow-y-auto overscroll-y-contain">
            <SupportSessionBanner />
            <Header />

            {/* 
              flex-1: ocupa todo el alto restante
              w-full: ocupa siempre todo el ancho disponible
            */}
            <main
              className={`flex-1 w-full px-2 sm:px-4 py-5 overflow-x-hidden ${className} ${
                isBusinessPage ? 'pt-24 sm:pt-4' : 'pt-24'
              }`}
            >
              {children}
            </main>
          </div>
        </div>
      </TryLucaChatProvider>
    </SidebarProvider>
  )
}

export default Layout
